import { render, staticRenderFns } from "./r-reward-generator-panels.vue?vue&type=template&id=712bdaad"
import script from "./r-reward-generator-panels.vue?vue&type=script&lang=js"
export * from "./r-reward-generator-panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('712bdaad')) {
      api.createRecord('712bdaad', component.options)
    } else {
      api.reload('712bdaad', component.options)
    }
    module.hot.accept("./r-reward-generator-panels.vue?vue&type=template&id=712bdaad", function () {
      api.rerender('712bdaad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward-generator/r-reward-generator-panels.vue"
export default component.exports